export default () => import(/* webpackChunkName: 'coffee/app/agreement/third-party' */ './ThirdParty.jsx');
